(() => {
  if (window.komMotion) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 699px)');
  const running = new Set();
  const latest = new WeakMap();
  function animate(element, frames, duration = 180) {
    if (!element || reduced.matches || !element.animate) return;
    latest.get(element)?.cancel();
    const animation = element.animate(frames, {duration, easing:'cubic-bezier(.22,1,.36,1)'});
    latest.set(element,animation);running.add(animation);
    animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
    return animation;
  }
  window.komMotion = {animate};
  reduced.addEventListener('change',()=>{if(reduced.matches)running.forEach(a=>a.finish());});
  const inViewport = el => {const r=el.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;};
  const revealed = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries=>{
    entries.forEach(({target,isIntersecting})=>{
      if(!isIntersecting)return;observer.unobserve(target);
      animate(target,[{opacity:.35,transform:`translateY(${mobile.matches?6:10}px)`},{opacity:1,transform:'translateY(0)'}],360);
      target.dataset.komRevealed='true';
    });
  },{threshold:0,rootMargin:'0px 0px -24px 0px'}):null;
  function editorial(root=document){
    root.querySelectorAll('.kom-home-editorial :is(.kom-categories,.kom-look,.kom-conditions,.kom-agenda,.kom-shortcuts--community,.kom-spotlight)').forEach(el=>{
      if(revealed.has(el))return;revealed.add(el);
      if(inViewport(el)||reduced.matches){el.dataset.komRevealed='true';return;}
      observer?.observe(el);
    });
  }
  function indicator(section){
    const tabs=section.querySelector('.kom-selection__tabs'),active=tabs?.querySelector('[aria-selected=true]');
    if(!active)return;
    let line=tabs.querySelector('.kom-selection__indicator');
    if(!line){line=document.createElement('span');line.className='kom-selection__indicator';line.setAttribute('aria-hidden','true');tabs.append(line);tabs.dataset.komIndicator='';}
    const a=active.getBoundingClientRect(),b=tabs.getBoundingClientRect();
    line.style.width=a.width+'px';line.style.transform=`translateX(${a.left-b.left+tabs.scrollLeft}px)`;
  }
  function setupTabs(root=document){
    root.querySelectorAll('kom-home-selection').forEach(section=>{
      if(section.dataset.komMotionTabs)return;section.dataset.komMotionTabs='true';indicator(section);
      if('ResizeObserver' in window){let width=section.clientWidth;new ResizeObserver(()=>{if(section.clientWidth!==width){width=section.clientWidth;section.querySelectorAll('[role=tabpanel]').forEach(p=>p.style.minHeight='');}indicator(section);}).observe(section);}
    });
  }
  document.addEventListener('kom:tab-change',event=>{
    const {panel,previousHeight}=event.detail;indicator(event.target);
    const height=Math.max(previousHeight,panel.getBoundingClientRect().height);
    if(height)event.target.querySelectorAll('[role=tabpanel]').forEach(p=>p.style.minHeight=height+'px');
    animate(panel,[{opacity:.4},{opacity:1}],200);
  });
  document.addEventListener('kom:results-change',event=>{
    const {list,animate:shouldAnimate,appendOnly,previousCount}=event.detail;
    if(!shouldAnimate)return;
    if(appendOnly){[...list.querySelectorAll('product-card')].slice(previousCount).filter(inViewport).forEach(el=>animate(el,[{opacity:.4},{opacity:1}],180));}
    else {animate(list,[{opacity:.5},{opacity:1}],180);event.target.section?.querySelectorAll('.kom-collection-summary__count').forEach(el=>animate(el,[{opacity:.4},{opacity:1}],180));}
  });
  document.addEventListener('kom:filter-change',event=>{
    const {group,value,color,backgroundColor,borderColor}=event.detail;
    if(!group||!value)return;
    document.querySelectorAll('.kom-category-chip').forEach(el=>{
      if(el.dataset.komGroup===group&&el.dataset.komValue===value){const now=getComputedStyle(el);animate(el,[{color,backgroundColor,borderColor},{color:now.color,backgroundColor:now.backgroundColor,borderColor:now.borderColor}],180);}
    });
  });
  const submissions=new WeakMap();
  const restore=button=>{delete button.dataset.komFeedback;delete button.dataset.komState;button.removeAttribute('aria-label');button.classList.remove('kom-motion-buy');};
  document.addEventListener('submit',event=>{
    const form=event.target,button=event.submitter;
    if(!form.closest('product-form')||!form.action.includes('/cart/add')||!button||!form.checkValidity())return;
    const old=submissions.get(form);if(old)clearTimeout(old.timer);
    button.classList.add('kom-motion-buy');button.dataset.komFeedback=document.body.dataset.komAdding;button.dataset.komState='pending';button.setAttribute('aria-label',button.dataset.komFeedback);
    submissions.set(form,{button,timer:setTimeout(()=>restore(button),15000)});
  },true);
  document.addEventListener('variant:add',event=>{
    const state=submissions.get(event.target);if(!state)return;clearTimeout(state.timer);
    state.button.dataset.komFeedback=document.body.dataset.komAdded;state.button.dataset.komState='success';state.button.setAttribute('aria-label',state.button.dataset.komFeedback);
    animate(state.button,[{opacity:.7},{opacity:1}],180);
    state.timer=setTimeout(()=>{restore(state.button);submissions.delete(event.target);},2200);
  });
  document.addEventListener('cart:error',event=>{const state=submissions.get(event.target);if(state){clearTimeout(state.timer);restore(state.button);submissions.delete(event.target);}});
  document.addEventListener('cart:change',()=>document.querySelectorAll('cart-count').forEach(el=>animate(el,[{opacity:.4},{opacity:1}],180)));
  document.addEventListener('variant:change',event=>{
    const section=event.target.closest('.shopify-section');if(!section)return;
    const gallery=section.querySelector('.VIM-slider-wrapper');
    if(gallery)animate(gallery,[{opacity:.65},{opacity:1}],200);
  });
  function pageAccordions(root=document){
    if(document.body.dataset.komPage!=='page')return;
    const page=root.querySelector('.shopify-section--main-page .prose');
    if(!page||page.dataset.komOrganized)return;page.dataset.komOrganized='true';
    const headings=[...page.children].filter(e=>/^H[23]$/.test(e.tagName)&&/\?$/.test(e.textContent.trim()));
    if(headings.length<3)return;
    headings.forEach(heading=>{
      const details=document.createElement('details'),summary=document.createElement('summary'),body=document.createElement('div');
      details.className='kom-page-accordion';body.className='kom-page-accordion__body';summary.textContent=heading.textContent;
      let next=heading.nextElementSibling;heading.replaceWith(details);details.append(summary,body);
      while(next&&!/^H[123]$/.test(next.tagName)){const sibling=next.nextElementSibling;body.append(next);next=sibling;}
    });
  }
  const disclosures=new WeakMap();
  document.addEventListener('click',event=>{
    const summary=event.target.closest('summary');const details=summary?.parentElement;
    if(!details?.matches('.kom-page-accordion,.kom-category-drawer details,.shopify-section--main-page .prose details'))return;
    if(event.target.closest('a,button,input'))return;
    if(reduced.matches)return;
    event.preventDefault();
    const existing=disclosures.get(details),opening=existing?!existing.opening:!details.open;
    const start=details.getBoundingClientRect().height;existing?.animation.cancel();
    details.style.overflow='hidden';details.open=true;
    const end=opening?details.scrollHeight:summary.getBoundingClientRect().height+parseFloat(getComputedStyle(details).paddingTop)+parseFloat(getComputedStyle(details).paddingBottom);
    const animation=animate(details,[{height:start+'px'},{height:end+'px'}],220);
    if(!animation){details.open=opening;details.style.overflow='';return;}
    disclosures.set(details,{animation,opening});
    animation.finished.then(()=>{details.open=opening;details.style.overflow='';disclosures.delete(details);}).catch(()=>{});
  });
  function newsletter(){
    const blocked=['product','cart'].includes(document.body.dataset.komPage);let elapsed=false;
    const check=()=>{
      const ready=!blocked&&elapsed&&scrollY>Math.min(400,innerHeight*.6)&&!document.querySelector('x-modal[open],cart-drawer[open],header-sidebar[open],facets-drawer[open],header-search[open]')&&!document.activeElement?.matches('input,textarea,select');
      document.body.toggleAttribute('data-kom-newsletter-ready',ready);
      document.querySelectorAll('shopify-forms-embed[id^="app-embed-container-"]').forEach(el=>{el.inert=!document.body.hasAttribute('data-kom-newsletter-ready');});
    };
    setTimeout(()=>{elapsed=true;check();},25000);
    addEventListener('scroll',check,{passive:true});document.addEventListener('focusout',check);document.addEventListener('focusin',check);document.addEventListener('dialog:after-show',check);document.addEventListener('dialog:after-hide',check);
    new MutationObserver(check).observe(document.body,{childList:true});check();
  }
  editorial();setupTabs();pageAccordions();newsletter();
  document.addEventListener('shopify:section:load',()=>{editorial();setupTabs();pageAccordions();});
})();
